export interface IPaymentItem {
    title: string;
    name: 'tonkeeper' | 'cryptomus';
    localeDesciption: string;
    imgURL: string;
}

export const PAYMENT_LIST: IPaymentItem[] = [
    {
        title: 'Tonkeeper',
        name: 'tonkeeper',
        localeDesciption: 'payment-will-be-made-in-TON',
        imgURL: process.env.PUBLIC_URL + '/images/replenishment/tonkeeper.png',
    },
    {
        title: 'Cryptomus',
        name: 'cryptomus',
        localeDesciption: 'payment-will-be-made-in-any-cryptocurrency',
        imgURL: process.env.PUBLIC_URL + '/images/replenishment/cryptomus.png',
    },
];
